import {ZIDXFormField} from "../form/FormField.js";
import {ZIDXFormFieldType} from "../form/FormFieldType.js";

export class ZIDXHTMLFormField extends ZIDXFormField{
    width:string="100%";
    height:string="300px";
    constructor(){
        super();
        this.type = ZIDXFormFieldType.HTML;
    }
}
